import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { IWorkDomain } from "../models/work-domain";

@Injectable({
  providedIn: "root",
})
export class WorkDomainService {
  public list: IWorkDomain[] = [];

  constructor(private _httpClient: HttpClient) {}

  async getList() {
    return this._httpClient
      .get("/work-domain")
      .toPromise()
      .then((response: IWorkDomain[]) => {
        const other: IWorkDomain = response.find((item: IWorkDomain) => item.name === "Altro");
        if (other) {
          response = response.filter((item: IWorkDomain) => item.name !== other.name);
          response.push(other);
        }
        this.list = response;
        return response;
      })
      .catch((err) => {
        console.error("WorkDomainService getList", err);
        return [];
      });
  }

  async updateDomain(id: number, data: IWorkDomain) {
    return this._httpClient
      .put("/work-domain/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }

  async createDomain(data: IWorkDomain) {
    return this._httpClient
      .post("/work-domain", data)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async deleteDomain(id: number) {
    return this._httpClient
      .delete("/work-domain/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }
}
